import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, renderSlot as _renderSlot, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-731809f1"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "ml-4" }
const _hoisted_2 = { class: "business-select ml-3" }

import { ref, onMounted, watch } from "vue";
import { useStore } from 'vuex';
import { format } from "date-fns";
import axios from "axios";
import AdminNaviBar from "./AdminNaviBar.vue";
import '@/assets/styles/layout.scss';
import router from "@/router";

interface SisulItem {
  sisul_code: string;
  sisul_name: string;
  sisul_biz_gubun: string;
  sisul_id: string;
  sisul_wage_in?: string;
  sisul_wage_out?: string;
  sisul_fna_in?: string;
  sisul_fna_out?: string;
  sisul_meal_in?: string;
  sisul_meal_out?: string;
}

// 유틸리티 함수

export default /*#__PURE__*/_defineComponent({
  __name: 'MainLayout',
  setup(__props) {

const store = useStore();

// 상태 관리
const btnActive = ref(false);
const AdminSisul = ref<string | null>(null);
const AdminBizGubun = ref<string | null>(null);
const AdminSisulId = ref<string | null>(null);

// 데이터 리스트
const sisulList = ref<string[]>([]);
const bizGubunList = ref<string[]>([]);
const serviceList = ref<string[]>([]);
const readSisulResult = ref<SisulItem[]>([]);

const toggleDrawer = () => {
  store.commit("setDrawer", !store.state.drawer);
};

const reloadBtn = () => {
  location.reload();
};

// API 호출
const readSisul = async () => {
  try {
    const response = await axios.get(`/api/getInChargeSisul`);
    const responseData = response.data;
    
    if (!responseData?.length) {
      console.error("responseData가 비어 있습니다.");
      return;
    }

    // 중복 제거
    readSisulResult.value = responseData.filter(
      (item: SisulItem, index: number, arr: SisulItem[]) => 
        arr.findIndex((i: SisulItem) => i.sisul_code === item.sisul_code) === index
    );

    // 리스트 생성
    sisulList.value = readSisulResult.value.map(
      item => `${item.sisul_name}(${item.sisul_code})`
    );

    updateBizGubunList();
    updateServiceList();
  } catch (error) {
    console.error("기관 정보 조회 중 오류 발생:", error);
  }
};

// 비즈니스 로직
const updateBizGubunList = () => {
  if (!AdminSisul.value) return;

  const matchedItem = readSisulResult.value.find(item => 
    `${item.sisul_name}(${item.sisul_code})` === AdminSisul.value
  );

  if (matchedItem) {
    bizGubunList.value = matchedItem.sisul_biz_gubun.split('/');
    AdminBizGubun.value = matchedItem.sisul_biz_gubun;
    AdminSisulId.value = matchedItem.sisul_id;
  }
};

const updateServiceList = () => {
  const today = format(new Date(), "yyyy-MM-dd");
  
  serviceList.value = readSisulResult.value.map(item => {
    const services = ["근태관리"];
    
    if (item.sisul_wage_in && item.sisul_wage_in <= today && (!item.sisul_wage_out || item.sisul_wage_out >= today)) {
      services.push("HR서비스");
    }
    if (item.sisul_fna_in && item.sisul_fna_in <= today && (!item.sisul_fna_out || item.sisul_fna_out >= today)) {
      services.push("재무회계");
    }
    if (item.sisul_meal_in && item.sisul_meal_in <= today && (!item.sisul_meal_out || item.sisul_meal_out >= today)) {
      services.push("위탁급식");
    }
    
    return services.join("/");
  });
};

const changeBtn = async () => {
  if (!btnActive.value) return;

  const sisulCode = AdminSisul.value?.match(/\(([^)]+)\)/)?.[1];
  const sisulName = AdminSisul.value?.replace(/\(.*\)$/, "");

  store.commit("setAdminSisul", AdminSisul.value);
  store.commit("setAdminSisulCode", sisulCode);
  store.commit("setAdminSisulName", sisulName);
  store.commit("setAdminBizGubun", AdminBizGubun.value);
  store.commit("setAdminSisulId", AdminSisulId.value);
  store.commit("setAdminService", serviceList.value);
  store.commit('setDrawer', true);
  if(AdminSisul.value === '' || AdminSisul.value === null){
    router.push('/AdminIndexPage');
  }else{
    reloadBtn();
  }
  btnActive.value = false;
};
const account = ref({
  emp_id: null,
  emp_name: "",
  emp_role: "",
});
const logout = () => {
  axios.delete("/api/account").then(() => {
    alert("로그아웃하였습니다.");
    account.value.emp_id = null;
    account.value.emp_name = "";
    account.value.emp_role = "";
    sessionStorage.removeItem("vuex_state");
    sessionStorage.removeItem("mainDateInfo");
    sessionStorage.removeItem("userInfoList");
    sessionStorage.removeItem("compInfoList");
    sessionStorage.removeItem("searchItem");
    localStorage.removeItem("vuex_state")
    window.location.reload();
  });
};
// Watchers
watch(AdminSisul, () => {
  updateBizGubunList();
  updateServiceList();
  
  if (!AdminSisul.value) {
    AdminBizGubun.value = "";
    AdminSisulId.value = "";
  }
});

watch([AdminSisul, AdminBizGubun], () => {
  btnActive.value = !(
    AdminSisul.value === store.state.AdminSisul &&
    AdminBizGubun.value === store.state.AdminBizGubun
  );
});

// Lifecycle Hooks
onMounted(async () => {
  AdminSisul.value = store.state.AdminSisul;
  AdminBizGubun.value = store.state.AdminBizGubun;
  AdminSisulId.value = store.state.AdminSisulId;

  await readSisul();
  btnActive.value = false;
});

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_autocomplete = _resolveComponent("v-autocomplete")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_app_bar = _resolveComponent("v-app-bar")!
  const _component_v_main = _resolveComponent("v-main")!
  const _component_v_app = _resolveComponent("v-app")!

  return (_openBlock(), _createBlock(_component_v_app, null, {
    default: _withCtx(() => [
      _createVNode(_component_v_app_bar, { class: "admin-app-bar" }, {
        default: _withCtx(() => [
          (_unref(store).state.AdminSisul)
            ? (_openBlock(), _createBlock(_component_v_icon, {
                key: 0,
                class: "ml-2",
                onClick: toggleDrawer,
                icon: "mdi-format-align-justify"
              }))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_1, [
            _createVNode(_component_v_autocomplete, {
              modelValue: AdminSisul.value,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((AdminSisul).value = $event)),
              label: "기관",
              items: sisulList.value,
              variant: "underlined",
              density: "compact",
              "hide-details": "auto",
              class: "longAutoCompleteText",
              clearable: "",
              "prepend-inner-icon": "mdi-city",
              "auto-select-first": ""
            }, null, 8, ["modelValue", "items"])
          ]),
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_v_select, {
              modelValue: AdminBizGubun.value,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((AdminBizGubun).value = $event)),
              label: "사업구분",
              items: bizGubunList.value,
              variant: "underlined",
              density: "compact",
              "hide-details": "auto",
              "prepend-inner-icon": "mdi-label-outline",
              "auto-select-first": ""
            }, null, 8, ["modelValue", "items"])
          ]),
          _createVNode(_component_v_btn, {
            class: _normalizeClass({ 'glamorous-button': true, active: btnActive.value }),
            onClick: _cache[2] || (_cache[2] = ($event: any) => (changeBtn()))
          }, {
            default: _withCtx(() => [
              _createTextVNode("적용")
            ]),
            _: 1
          }, 8, ["class"]),
          _createVNode(_component_v_spacer),
          _createVNode(_component_v_btn, { onClick: reloadBtn }, {
            default: _withCtx(() => [
              _createTextVNode("새로고침")
            ]),
            _: 1
          }),
          _createVNode(_component_v_btn, { onClick: logout }, {
            default: _withCtx(() => [
              _createTextVNode(" 로그아웃 "),
              _createVNode(_component_v_icon, null, {
                default: _withCtx(() => [
                  _createTextVNode("mdi-logout-variant")
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(AdminNaviBar),
      _createVNode(_component_v_main, null, {
        default: _withCtx(() => [
          _createElementVNode("div", null, [
            _renderSlot(_ctx.$slots, "default")
          ])
        ]),
        _: 3
      })
    ]),
    _: 3
  }))
}
}

})